<template>
    <div v-resize="230" class="left-nav__container">
        <leftNav style="width: 100%;" v-bind="$attrs" v-on="$listeners"></leftNav>
    </div>
</template>

<script>
import leftNav from './leftNavInner.vue'
export default {
    components: { leftNav},
    data() {
        return {}
    }
}
</script>

<style lang="scss">
.left-nav__container {
    height: 100%;
    min-width: 230px;
    overflow: hidden;
    flex-shrink: 0;
    position: relative;
}
</style>